export const visit = (vm, at) => {
at({ "en": { "accountingExtension": { "invoiceStatus": { "CREATED": "Waiting to be sent", "SENT": "Sent to customer", "PAID": "Payment received", "CLOSED": "Fully paid", "OVERDUE": "Overdue", "VOIDED": "Voided", "NONE": "None", "UNPAID": "Unpaid" } } } });
};